module.exports = __webpack_public_path__ + "static/media/47_A.46de5609.png";